import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AttachmentPopup from './AttachmentPopup';

/**
 * FilePreviewPage
 * A lightweight page component to display only the AttachmentPopup.
 * Extracts ReferenceID and popupID from the URL parameters to show document attachments.
 */
const FilePreviewPage = () => {
    /* === 1. ROUTE PARAMS & LOCAL STATE === */
    const { ReferenceID, popupID } = useParams();
    const [attachmentRow, setAttachmentRow] = useState(null);

    useEffect(() => {
        if (ReferenceID) {
            setAttachmentRow({ id: ReferenceID });
        }
    }, [ReferenceID]);

    const handleAttachmentClose = () => {
        setAttachmentRow(null);
        if (popupID) {
            window.parent.postMessage(`popuphide|${popupID}`, "*");
        }
        // Optional: navigate back or close window after popup is closed.
        // For now, it will just show a blank page.
    };

    return (
        <AttachmentPopup 
            open={Boolean(attachmentRow)} 
            onClose={handleAttachmentClose} 
            row={attachmentRow}
            hideHeader={true} 
        />
    );
};

export default FilePreviewPage;
